import React from "react";
import SectorLayout from "@/components/SectorLayout";
import data from "@/data/sectors/education";
export default function SecteurEducation() { return <SectorLayout data={data} />; }
